module.exports = __webpack_public_path__ + "img/banner-small.d499049b.png";